import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconChevronRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#818181",
		d: "M7.158 13.617l3.817-3.825-3.817-3.825 1.175-1.175 5 5-5 5-1.175-1.175z"
	})
});
export default SvgIconChevronRight;
